'use client'

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import { forwardRef, useCallback, useEffect, useRef, type ComponentPropsWithoutRef, type ElementRef } from 'react'
import { cn } from '@/ui/utils/style'

const Root = CollapsiblePrimitive.Root
const Trigger = CollapsiblePrimitive.Trigger

const Content = forwardRef<
  ElementRef<typeof CollapsiblePrimitive.Content>,
  ComponentPropsWithoutRef<typeof CollapsiblePrimitive.Content>
>(({ className, ...props }, forwardedRef) => {
  const isInitialRender = useRef(true)

  useEffect(() => {
    isInitialRender.current = false
  }, [])

  const callbackRef = useCallback(
    (node: ElementRef<typeof CollapsiblePrimitive.Content> | null) => {
      if (node && isInitialRender.current) {
        node.style.animationDuration = '0s'
        requestAnimationFrame(() => {
          node.style.animationDuration = ''
        })
      }
      if (typeof forwardedRef === 'function') forwardedRef(node)
      else if (forwardedRef) forwardedRef.current = node
    },
    [forwardedRef],
  )

  return (
    <CollapsiblePrimitive.Content
      ref={callbackRef}
      className={cn(
        'overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down',
        className,
      )}
      {...props}
    />
  )
})
Content.displayName = 'CollapsibleContent'

export { Root, Trigger, Content }
